import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { ContentBlocksModuleLayout } from "entities/modules/types";
import {
  defaultTextBlock,
  defaultThreeCardBlock,
  defaultOneCardBlock,
} from "entities/modules/utils";
import CardWithPlaceholder from "entities/modules/widgets/CardWithPlaceholder";
import OneCardBlockPlaceholder from "entities/modules/widgets/OneCardBlockPlaceholder";
import TextBlockPlaceholder from "entities/modules/widgets/TextBlockPlaceholder";
import ThreeCardBlockPlaceholder from "entities/modules/widgets/ThreeCardBlockPlaceholder";
import { useGeneralData } from "modules/brands/pages/ModulesContainer/components/PageModules/components/ModuleDetailsDrawer/stores/useGeneralData";
import { type FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";

const ModuleLayoutSection: FC = () => {
  const { moduleLayout, setModuleLayout, setContentBlocks } = useGeneralData();
  const onSelectThreeCardBlock = () => {
    setModuleLayout(ContentBlocksModuleLayout.ThreeCardBlock);
    setContentBlocks(defaultThreeCardBlock());
  };

  const onSelectTextBlock = () => {
    setModuleLayout(ContentBlocksModuleLayout.TextBlock);
    setContentBlocks(defaultTextBlock());
  };

  const onSelectOneCardBlock = () => {
    setModuleLayout(ContentBlocksModuleLayout.OneCardBlock);
    setContentBlocks(defaultOneCardBlock());
  };
  return (
    <ContentSection title="Module Layout">
      <Stack spacing="1rem">
        <Box display="flex" width="100%" gap="0.5rem">
          <CardWithPlaceholder
            text="Three Card Block"
            isActive={moduleLayout === ContentBlocksModuleLayout.ThreeCardBlock}
            placeholder={<ThreeCardBlockPlaceholder />}
            onSelect={onSelectThreeCardBlock}
          />
          <CardWithPlaceholder
            text="Text Block"
            isActive={moduleLayout === ContentBlocksModuleLayout.TextBlock}
            placeholder={<TextBlockPlaceholder />}
            onSelect={onSelectTextBlock}
          />
          <CardWithPlaceholder
            text="One Card Block"
            isActive={moduleLayout === ContentBlocksModuleLayout.OneCardBlock}
            placeholder={<OneCardBlockPlaceholder />}
            onSelect={onSelectOneCardBlock}
          />
        </Box>
      </Stack>
    </ContentSection>
  );
};

export default ModuleLayoutSection;
